module.exports = __webpack_public_path__ + "banner-recruiter.f1870d0d507c7c04820e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/background/banner-recruiter.png
// module id = 489
// module chunks = 5